import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { InfoIcon } from "lucide-react";

export function Kpi({ label, value, hint, tone = "default", testId }) {
  const bg = tone === "primary" ? "bg-[#0A2A5E] text-white" : "bg-white dark:bg-[#131B2A]";
  const sub = tone === "primary" ? "text-sky-100" : "text-slate-500";
  return (
    <div data-testid={testId} className={`${bg} rounded-xl border ${tone === "primary" ? "border-[#0A2A5E]" : "border-slate-200 dark:border-[#25334D]"} p-5 shadow-sm`}>
      <div className={`text-xs uppercase tracking-wider ${sub} font-semibold`}>{label}</div>
      <div className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">{value}</div>
      {hint && <div className={`mt-1 text-[11px] ${sub}`}>{hint}</div>}
    </div>
  );
}

export function Section({ title, subtitle, right, children, testId }) {
  return (
    <Card className="border-slate-200 dark:border-[#25334D]" data-testid={testId}>
      <CardContent className="p-5 sm:p-6">
        <div className="flex items-start justify-between gap-3 mb-4">
          <div>
            <h2 className="text-lg font-semibold tracking-tight text-slate-900 dark:text-slate-50">{title}</h2>
            {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          {right && <div className="shrink-0">{right}</div>}
        </div>
        {children}
      </CardContent>
    </Card>
  );
}

export function EmptyState({ title, description, action, testId = "empty-state" }) {
  return (
    <div data-testid={testId} className="text-center py-10 px-4 border border-dashed border-slate-200 dark:border-[#25334D] rounded-lg bg-slate-50/50 dark:bg-[#0F1729]">
      <div className="text-sm font-semibold text-slate-700 dark:text-slate-200">{title}</div>
      {description && <div className="text-xs text-slate-500 mt-1 max-w-md mx-auto">{description}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}

export function Loading({ label = "Cargando…" }) {
  return (
    <div className="py-10 text-center text-sm text-slate-500" role="status" aria-live="polite">
      <div className="inline-block w-5 h-5 rounded-full border-2 border-slate-300 border-t-[#026FCB] animate-spin align-middle mr-2" />
      {label}
    </div>
  );
}

export function Tip({ children }) {
  return (
    <span className="inline-flex items-center gap-1 text-[11px] text-slate-500" title={typeof children === "string" ? children : undefined}>
      <InfoIcon size={12} /> {children}
    </span>
  );
}

export function StatusDot({ ok, label }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs ${ok ? "text-emerald-700 dark:text-emerald-400" : "text-slate-500"}`}>
      <span className={`w-2 h-2 rounded-full ${ok ? "bg-emerald-500" : "bg-slate-300"}`} />
      {label}
    </span>
  );
}
